import type { ReactNode } from 'react';
import { cx } from '../lib/cx';
import styles from './SectionHeader.module.css';

type Props = {
  /** Terminal-style line above the heading, e.g. "$ ls -la ./services". */
  prompt: string;
  title: ReactNode;
  intro?: ReactNode;
  /** Wider spacing for the two-column sections. */
  loose?: boolean;
  className?: string;
};

export function SectionHeader({ prompt, title, intro, loose, className }: Props) {
  return (
    <div className={cx(styles.header, loose && styles.loose, className)}>
      <div className={styles.prompt}>{prompt}</div>
      <h2>{title}</h2>
      {intro && <p className={cx(styles.intro, loose && styles.introWide)}>{intro}</p>}
    </div>
  );
}
